import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for J515 (研發託工單核准)
// ============================================================

export interface ApproveCandidate {
  fj610_01: string;   // 託工單號
  fj610_11: string;   // 託工日期 (YYYY-MM-DD)
  fj610_12: string;   // 廠商代碼
  fj610_13: string;   // 廠商名稱
  fj610_14: number;   // 金額
  fj610_21: string;   // 部門代碼
  fj610_80: string;   // 核准狀態
  dept_name: string;  // 部門名稱
}

export interface QueryResponse {
  items: ApproveCandidate[];
  total: number;
}

export interface ApproveItem {
  no: string;       // FJ610_01
  checked: boolean; // 是否勾選
}

export interface ApproveRequest {
  items: ApproveItem[];
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const j515Api = {
  /** Query R&D subcontract order records eligible for approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/j515/candidates', { params });
    return res.data;
  },

  /** Execute batch approval for selected R&D subcontract order records */
  async approve(request: ApproveRequest): Promise<ApproveResponse> {
    const { items } = request;
    const res = await apiClient.post('/api/j515/approve', { items, confirmed: true });
    return res.data;
  },
};
